import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from "@angular/router";
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {ViewMode} from "../../interfaces";
import Swal from 'sweetalert2';
import moment from 'moment';
import {Subscription} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {MessageService} from "../../../services/message.service";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {StatusPipe} from "../../../pipes/status.pipe";
import {TypeaheadDirective} from "ngx-bootstrap/typeahead";
import {FiletypePipe} from "../../../pipes/filetype.pipe";

@Component({
    selector: 'app-task-detail',
    templateUrl: './task-detail.component.html',
    imports: [
        NgIf,
        ReactiveFormsModule,
        StatusPipe,
        DatePipe,
        RouterLink,
        TypeaheadDirective,
        FiletypePipe,
        NgForOf
    ],
    styleUrl: './task-detail.component.scss'
})
export class TaskDetailComponent implements OnInit, OnDestroy, AfterViewInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);
    private messageService = inject(MessageService);

    @ViewChild('audioElement') audioElementRef: ElementRef<HTMLAudioElement>;
    @ViewChild('inputFile') inputFile: ElementRef;

    get audioElement(): HTMLAudioElement {
        return this.audioElementRef.nativeElement;
    }

    ViewMode = ViewMode;

    today;

    form!: UntypedFormGroup;
    id_task!: string;
    viewMode!: ViewMode;
    users!: any[];
    customers!: any[];
    contacts!: any[];
    task: any;
    files: any[] = [];
    newFiles: any[] = [];
    dueDateChanges$!: Subscription;
    customerChanges$!: Subscription;
    contactChanges$!: Subscription;
    departmentChanges$!: Subscription;
    tasktypes: any[];
    departments: any[];
    noResult;
    noResultContact;
    saving = false;

    navigationSubscription$: Subscription;

    // Audio recording stuff below
    recording = false;
    playing = false;
    audioRecorder;
    elapsedTime;
    notSupported = false;
    audioElementSource;

    /** Stores the maximum recording time in hours to stop recording once maximum recording hour has been reached */
    maximumRecordingTimeInHours = 1;

    /** Stores the actual start time when an audio recording begins to take place to ensure elapsed time start time is accurate*/
    audioRecordStartTime;

    /** Stores the reference of the setInterval function that controls the timer in audio recording*/
    elapsedTimeTimer;

    constructor() {
        this.navigationSubscription$ = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                this.load();
            }
        });
    }

    ngAfterViewInit(): void {
        this.createSourceForAudioElement();
    }

    ngOnInit(): void {
        this.today = moment().format("YYYY-MM-DD");

        this.audioRecorder = {
            /** Stores the recorded audio as Blob objects of audio data as the recording continues*/
            audioBlobs: [],/*of type Blob[]*/
            /** Stores the reference of the MediaRecorder instance that handles the MediaStream when recording starts*/
            mediaRecorder: null, /*of type MediaRecorder*/
            /** Stores the reference to the stream currently capturing the audio*/
            streamBeingCaptured: null, /*of type MediaStream*/
            /** Start recording the audio
             * @returns {Promise} - returns a promise that resolves if audio recording successfully started
             */
            start: () => {
                //Feature Detection
                if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
                    //Feature is not supported in browser
                    //return a custom error
                    return Promise.reject(new Error('mediaDevices API or getUserMedia method is not supported in this browser.'));
                } else {
                    //Feature is supported in browser

                    //create an audio stream
                    return navigator.mediaDevices.getUserMedia({audio: true}/*of type MediaStreamConstraints*/)
                        //returns a promise that resolves to the audio stream
                        .then(stream /*of type MediaStream*/ => {

                            //save the reference of the stream to be able to stop it when necessary
                            this.audioRecorder.streamBeingCaptured = stream;

                            //create a media recorder instance by passing that stream into the MediaRecorder constructor
                            this.audioRecorder.mediaRecorder = new MediaRecorder(stream); /*the MediaRecorder interface of the MediaStream Recording
                    API provides functionality to easily record media*/

                            //clear previously saved audio Blobs, if any
                            this.audioRecorder.audioBlobs = [];

                            //add a dataavailable event listener in order to store the audio data Blobs when recording
                            this.audioRecorder.mediaRecorder.addEventListener("dataavailable", event => {
                                //store audio Blob object
                                this.audioRecorder.audioBlobs.push(event.data);
                            });

                            //start the recording by calling the start method on the media recorder
                            this.audioRecorder.mediaRecorder.start();
                        });

                    /* errors are not handled in the API because if its handled and the promise is chained, the .then after the catch will be executed*/
                }
            },
            /** Stop the started audio recording
             * @returns {Promise} - returns a promise that resolves to the audio as a blob file
             */
            stop: () => {
                //return a promise that would return the blob or URL of the recording
                return new Promise(resolve => {
                    //save audio type to pass to set the Blob type
                    let mimeType = this.audioRecorder.mediaRecorder.mimeType;

                    //listen to the stop event in order to create & return a single Blob object
                    this.audioRecorder.mediaRecorder.addEventListener("stop", () => {
                        //create a single blob object, as we might have gathered a few Blob objects that needs to be joined as one
                        let audioBlob = new Blob(this.audioRecorder.audioBlobs, {type: mimeType});

                        //resolve promise with the single audio blob representing the recorded audio
                        resolve(audioBlob);
                    });
                    this.audioRecorder.cancel();
                });
            },
            /** Cancel audio recording*/
            cancel: () => {
                //stop the recording feature
                this.audioRecorder.mediaRecorder.stop();

                //stop all the tracks on the active stream in order to stop the stream
                this.audioRecorder.stopStream();

                //reset API properties for next recording
                this.audioRecorder.resetRecordingProperties();
            },
            /** Stop all the tracks on the active stream in order to stop the stream and remove
             * the red flashing dot showing in the tab
             */
            stopStream: () => {
                //stopping the capturing request by stopping all the tracks on the active stream
                this.audioRecorder.streamBeingCaptured.getTracks() //get all tracks from the stream
                    .forEach(track /*of type MediaStreamTrack*/ => track.stop()); //stop each one
            },
            /** Reset all the recording properties including the media recorder and stream being captured*/
            resetRecordingProperties: () => {
                this.audioRecorder.mediaRecorder = null;
                this.audioRecorder.streamBeingCaptured = null;

                /*No need to remove event listeners attached to mediaRecorder as
                If a DOM element which is removed is reference-free (no references pointing to it), the element itself is picked
                up by the garbage collector as well as any event handlers/listeners associated with it.
                getEventListeners(audioRecorder.mediaRecorder) will return an empty array of events.*/
            }
        }

        this.load();
    }

    ngOnDestroy(): void {
        this.dueDateChanges$.unsubscribe();
        this.customerChanges$.unsubscribe();
        this.contactChanges$.unsubscribe();
        this.departmentChanges$?.unsubscribe();

        this.navigationSubscription$?.unsubscribe();
    }

    load() {
        this.id_task = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_task == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_creator: [this.accessService.user.id],
            id_customer: [''],
            id_contact: [''],
            id_tasktype: ['', Validators.required],
            id_department: [null],
            id_editor: [{value: '', disabled: this.id_task == '0'}],
            title: [null, Validators.required],
            description: [null, Validators.required],
            due_date: [this.today, Validators.required],
            reminder_date: [this.today],
            contact_phone: [null],
            contact_email: [null],
            archived: [null],
            created_at: [null],
            creator: [null],
            editor: [null],
            customer: [null],
            contact: [null],
            tasktype: [null],
            department: ['', Validators.required],
            status: [null],
            new_status: [null, Validators.required],

            new_contact_name: [{value: null, disabled: true}, Validators.required],
            new_contact_zip: [null],
            new_contact_city: [null],
            new_contact_street: [null],
            new_contact_phone: [null],
            new_contact_mail: [null],

            select_customer: [''],
            select_contact: [''],
        });

        // enable users
        if (this.id_task == '0') {
            this.departmentChanges$ = this.form.get('department').valueChanges.subscribe(val => {
                this.form.controls.id_editor.enable();
                this.form.patchValue({
                    id_editor: ''
                })
            });
        }

        // prevent reminder being after due date
        this.dueDateChanges$ = this.form.get('due_date').valueChanges.subscribe(val => {
            if (moment(this.form.value.reminder_date).isAfter(moment(val), 'day')) {
                this.form.patchValue({
                    reminder_date: val,
                });
            }
        });

        // set either customer or contact
        this.customerChanges$ = this.form.get('select_customer').valueChanges.subscribe(val => {
            if (val == '') {
                this.form.controls['select_contact'].enable({emitEvent: false});
            } else {
                this.form.patchValue({
                    id_contact: '',
                });
                this.form.controls['select_contact'].disable({emitEvent: false});
            }
        });
        this.contactChanges$ = this.form.get('select_contact').valueChanges.subscribe(val => {
            if (val == '') {
                this.form.controls['select_customer'].enable({emitEvent: false});
                this.form.controls['new_contact_name'].disable({emitEvent: false})
            } else {
                this.form.patchValue({
                    id_customer: '',
                });
                this.form.controls['select_customer'].disable({emitEvent: false});

                if (val == 'Neu') {
                    this.form.controls['new_contact_name'].enable({emitEvent: false});
                }
            }
        });

        this.dataService.request('User/listForTask').subscribe(response => {
            this.users = response.users;
        });

        this.dataService.request('Customer/listForTask').subscribe(response => {
            this.customers = response.customers;

            // populate customer when task create was opened from customer page
            const id_customer = this.messageService.getItem('create_task_customer', true);
            if (id_customer) {
                this.form.patchValue({
                    select_customer: this.customers.find(customer => customer.id == id_customer).select_name,
                    id_customer: id_customer,
                })
            }
        });

        this.dataService.request('Contact/listForTask').subscribe(response => {
            this.contacts = response.contacts;
            this.contacts.push({id: '0', name: 'Neu'});
        });

        this.dataService.request('Tasktype/listForLists').subscribe(response => {
            this.tasktypes = response.tasktypes;
        });

        this.dataService.request('Department/listForTask').subscribe(response => {
            this.departments = response.departments;

            if (this.id_task !== '0') {
                this.getTask();
            }
        });
    }

    getTask(): void {
        this.dataService.request('Task/get', {
            id_task: this.id_task
        }).subscribe(response => {
            this.task = response.task;
            this.task.archived = parseInt(this.task.archived, 10);

            this.task.descriptionConverted = this.task.description.replaceAll("\n", "<br/>");

            this.files = response.files;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.task.id,
            id_creator: this.task.id_creator,
            id_customer: this.task.id_customer,
            id_contact: this.task.id_contact ?? '',
            id_tasktype: this.task.id_tasktype,
            id_department: this.task.id_department,
            id_editor: this.task.id_editor ?? '',
            title: this.task.title,
            description: this.task.description,
            due_date: this.task.due_date,
            reminder_date: this.task.reminder_date,
            contact_phone: this.task.contact_phone,
            contact_email: this.task.contact_email,
            archived: this.task.archived,
            created_at: this.task.created_at,
            creator: this.task.creator,
            editor: this.task.editor,
            customer: this.task.customer,
            contact: this.task.contact,
            tasktype: this.task.tasktype,
            department: this.departments.find(department => department.name == this.task.department),
            status: this.task.status,
            new_status: this.task.status.name,

            select_customer: this.task.customer ?? '',
            select_contact: this.task.contact ?? '',
        });
    }

    save(): void {
        this.saving = true;
        this.dataService.request('Task/save', {
            task: this.form.getRawValue(),
            new_files: this.newFiles,
        }).subscribe(() => {
            this.saving = false;
            this.router.navigate(['/task']);
            this.toastrService.success('Der Aufgabe wurde gespeichert');
        });
    }

    update(): void {
        this.saving = true;
        this.dataService.request('Task/update', {
            task: this.form.getRawValue(),
            new_files: this.newFiles,
        }).subscribe(() => {
            this.saving = false;
            this.newFiles = [];
            this.inputFile.nativeElement.value = '';

            this.setMode(ViewMode.VIEW);
            this.getTask();
            this.toastrService.success('Der Aufgabe wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/task']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Aufgabe wird in den Papierkorb verschoben.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Task/delete', {
                    id_task: this.id_task
                }).subscribe(() => {
                    this.getTask();
                    this.messageService.sendMessage('delete');
                    this.toastrService.success('Der Aufgabe wurde in den Papierkorb verschoben');
                });
            }
        });
    }

    undelete(): void {
        this.dataService.request('Task/undelete', {
            id_task: this.id_task
        }).subscribe(() => {
            this.getTask();
            this.messageService.sendMessage('undelete');
            this.toastrService.success('Die Aufgabe wurde wiederhergestellt');
        });
    }

    archive(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Aufgabe wird ins Archiv verschoben.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Task/archive', {
                    id_task: this.id_task
                }).subscribe(() => {
                    this.getTask();
                    this.toastrService.success('Die Aufgabe wurde archiviert');
                });
            }
        });
    }

    unarchive(): void {
        this.dataService.request('Task/unarchive', {
            id_task: this.id_task
        }).subscribe(() => {
            this.getTask();
            this.toastrService.success('Die Aufgabe wurde wiederhergestellt');
        });
    }

    handleInputChange(e): void {
        for (let i = 0; i < e.target.files.length; i++) {
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                this.newFiles.push({
                    id: null,
                    name: e.target.files[i].name,
                    size: e.target.files[i].size,
                    type: e.target.files[i].type,
                    data: progressEvent.target.result
                });
            };
            reader.readAsDataURL(e.target.files[i]);
        }
    }

    deleteFile(file): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Anhang wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('File/delete', {
                    id: file.id
                }).subscribe(() => {
                    this.getTask();
                    this.toastrService.success('Der Anhang wurde gelöscht');
                });
            }
        });
    }

    getFileData(file): void {
        this.dataService.request("File/getData", {
            id: file.id
        }).subscribe(response => {
            if (response.data.type.startsWith('audio/')) {
                //data:audio/webm;codecs=opus;base64,
                this.audioElementSource.src = 'data:' + response.data.type + ';base64,' + response.data.data;

                //call the load method as it is used to update the audio element after changing the source or other settings
                this.audioElement.load();

                //play the audio after successfully setting new src and type that corresponds to the recorded audio
                console.log("Playing audio...");
                this.audioElement.play();
                this.playing = true;
            } else {
                const link = document.createElement('a');

                link.setAttribute('href', 'data:' + response.data.type + ';base64,' + response.data.data);
                link.setAttribute('download', response.data.name);
                link.click();
            }
        });
    }

    // Recorder

    /** Displays recording control buttons */
    handleDisplayingRecordingControlButtons() {
        //Hide the microphone button that starts audio recording
        this.recording = true;

        //Handle the displaying of the elapsed recording time
        this.handleElapsedRecordingTime();
    }

    /** Hide the displayed recording control buttons */
    handleHidingRecordingControlButtons() {
        //Display the microphone button that starts audio recording
        this.recording = false;

        //stop interval that handles both time elapsed and the red dot
        clearInterval(this.elapsedTimeTimer);
    }

    /** Creates a source element for the audio element in the HTML document*/
    createSourceForAudioElement() {
        let sourceElement = document.createElement("source");
        this.audioElement.appendChild(sourceElement);

        this.audioElementSource = sourceElement;
    }

    /** Starts the audio recording*/
    startAudioRecording() {

        console.log("Recording Audio...");

        //If a previous audio recording is playing, pause it
        let recorderAudioIsPlaying = !this.audioElement.paused; // the paused property tells whether the media element is paused or not
        console.log("paused?", !recorderAudioIsPlaying);
        if (recorderAudioIsPlaying) {
            this.audioElement.pause();
            //also hide the audio playing indicator displayed on the screen
            this.playing = false;
        }

        //start recording using the audio recording API
        this.audioRecorder.start()
            .then(() => { //on success

                //store the recording start time to display the elapsed time according to it
                this.audioRecordStartTime = new Date();

                //display control buttons to offer the functionality of stop and cancel
                this.handleDisplayingRecordingControlButtons();
            })
            .catch(error => { //on error
                //No Browser Support Error
                if (error.message.includes("mediaDevices API or getUserMedia method is not supported in this browser.")) {
                    console.log("To record audio, use browsers like Chrome and Firefox.");
                    this.notSupported = true;
                }

                //Error handling structure
                switch (error.name) {
                    case 'AbortError': //error from navigator.mediaDevices.getUserMedia
                        console.log("An AbortError has occured.");
                        break;
                    case 'NotAllowedError': //error from navigator.mediaDevices.getUserMedia
                        console.log("A NotAllowedError has occured. User might have denied permission.");
                        break;
                    case 'NotFoundError': //error from navigator.mediaDevices.getUserMedia
                        console.log("A NotFoundError has occured.");
                        break;
                    case 'NotReadableError': //error from navigator.mediaDevices.getUserMedia
                        console.log("A NotReadableError has occured.");
                        break;
                    case 'SecurityError': //error from navigator.mediaDevices.getUserMedia or from the MediaRecorder.start
                        console.log("A SecurityError has occured.");
                        break;
                    case 'TypeError': //error from navigator.mediaDevices.getUserMedia
                        console.log("A TypeError has occured.");
                        break;
                    case 'InvalidStateError': //error from the MediaRecorder.start
                        console.log("An InvalidStateError has occured.");
                        break;
                    case 'UnknownError': //error from the MediaRecorder.start
                        console.log("An UnknownError has occured.");
                        break;
                    default:
                        console.log("An error occured with the error name " + error.name);
                }
            });
    }

    /** Stop the currently started audio recording & sends it
     */
    stopAudioRecording() {

        console.log("Stopping Audio Recording...");

        //stop the recording using the audio recording API
        this.audioRecorder.stop()
            .then(audioAsblob => {
                //Play recorder audio
                this.playAudio(audioAsblob);

                //hide recording control button & return record icon
                this.handleHidingRecordingControlButtons();
            })
            .catch(error => {
                //Error handling structure
                switch (error.name) {
                    case 'InvalidStateError': //error from the MediaRecorder.stop
                        console.log("An InvalidStateError has occured.");
                        break;
                    default:
                        console.log("An error occured with the error name " + error.name);
                }
            });
    }

    /** Cancel the currently started audio recording */
    cancelAudioRecording() {
        console.log("Canceling audio...");

        //cancel the recording using the audio recording API
        this.audioRecorder.cancel();

        //hide recording control button & return record icon
        this.handleHidingRecordingControlButtons();
    }

    /** Plays recorded audio using the audio element in the HTML document
     * @param {Blob} recorderAudioAsBlob - recorded audio as a Blob Object
     */
    playAudio(recorderAudioAsBlob) {

        //read content of files (Blobs) asynchronously
        let reader = new FileReader();

        //once content has been read
        reader.onload = (e) => {
            //store the base64 URL that represents the URL of the recording audio
            let base64URL = e.target.result;

            this.newFiles.push({
                name: "Audioaufnahme",
                // @ts-ignore
                type: e.target.result.split(";")[0].split(":")[1],
                data: e.target.result
            });

            /*

            //If this is the first audio playing, create a source element
            //as pre-populating the HTML with a source of empty src causes error
            if (!this.audioElementSource) //if it's not defined create it (happens first time only)
                this.createSourceForAudioElement();

            //set the audio element's source using the base64 URL
            this.audioElementSource.src = base64URL;

            //set the type of the audio element based on the recorded audio's Blob type
            let BlobType = recorderAudioAsBlob.type.includes(";") ?
                recorderAudioAsBlob.type.substr(0, recorderAudioAsBlob.type.indexOf(';')) : recorderAudioAsBlob.type;
            this.audioElementSource.type = BlobType;

            //call the load method as it is used to update the audio element after changing the source or other settings
            this.audioElement.load();

            //play the audio after successfully setting new src and type that corresponds to the recorded audio
            console.log("Playing audio...");
            this.audioElement.play();

            //Display text indicator of having the audio play in the background
            this.playing = true;

            */
        };

        //read content and convert it to a URL (base64)
        reader.readAsDataURL(recorderAudioAsBlob);
    }

    /** Computes the elapsed recording time since the moment the function is called in the format h:m:s*/
    handleElapsedRecordingTime() {
        //display inital time when recording begins
        this.displayElapsedTimeDuringAudioRecording("00:00");

        //create an interval that compute & displays elapsed time, as well as, animate red dot - every second
        this.elapsedTimeTimer = setInterval(() => {
            //compute the elapsed time every second
            let elapsedTime = this.computeElapsedTime(this.audioRecordStartTime); //pass the actual record start time
            //display the elapsed time
            this.displayElapsedTimeDuringAudioRecording(elapsedTime);
        }, 1000); //every second
    }

    /** Display elapsed time during audio recording
     * @param {String} elapsedTime - elapsed time in the format mm:ss or hh:mm:ss
     */
    displayElapsedTimeDuringAudioRecording(elapsedTime) {
        //1. display the passed elapsed time as the elapsed time in the elapsedTime HTML element
        this.elapsedTime = elapsedTime;

        //2. Stop the recording when the max number of hours is reached
        if (this.elapsedTimeReachedMaximumNumberOfHours(elapsedTime)) {
            this.stopAudioRecording();
        }
    }

    /**
     * @param {String} elapsedTime - elapsed time in the format mm:ss or hh:mm:ss
     * @returns {Boolean} whether the elapsed time reached the maximum number of hours or not
     */
    elapsedTimeReachedMaximumNumberOfHours(elapsedTime) {
        //Split the elapsed time by the symbo :
        let elapsedTimeSplitted = elapsedTime.split(":");

        //Turn the maximum recording time in hours to a string and pad it with zero if less than 10
        let maximumRecordingTimeInHoursAsString = this.maximumRecordingTimeInHours < 10 ? "0" + this.maximumRecordingTimeInHours : this.maximumRecordingTimeInHours.toString();

        //if the elapsed time reach hours and also reach the maximum recording time in hours return true
        if (elapsedTimeSplitted.length === 3 && elapsedTimeSplitted[0] === maximumRecordingTimeInHoursAsString)
            return true;
        else //otherwise, return false
            return false;
    }

    /** Computes the elapsedTime since the moment the function is called in the format mm:ss or hh:mm:ss
     * @param {String} startTime - start time to compute the elapsed time since
     * @returns {String} elapsed time in mm:ss format or hh:mm:ss format, if elapsed hours are 0.
     */
    computeElapsedTime(startTime) {
        //record end time
        let endTime = new Date();

        //time difference in ms
        // @ts-ignore
        let timeDiff = endTime - startTime;

        //convert time difference from ms to seconds
        timeDiff = timeDiff / 1000;

        //extract integer seconds that dont form a minute using %
        let seconds = Math.floor(timeDiff % 60); //ignoring uncomplete seconds (floor)

        //pad seconds with a zero if neccessary
        let secondsString = seconds < 10 ? "0" + seconds : seconds;

        //convert time difference from seconds to minutes using %
        timeDiff = Math.floor(timeDiff / 60);

        //extract integer minutes that don't form an hour using %
        let minutes = timeDiff % 60; //no need to floor possible incomplete minutes, becase they've been handled as seconds
        let minutesString = minutes < 10 ? "0" + minutes : minutes;

        //convert time difference from minutes to hours
        timeDiff = Math.floor(timeDiff / 60);

        //extract integer hours that don't form a day using %
        let hours = timeDiff % 24; //no need to floor possible incomplete hours, becase they've been handled as seconds

        //convert time difference from hours to days
        timeDiff = Math.floor(timeDiff / 24);

        // the rest of timeDiff is number of days
        let days = timeDiff; //add days to hours

        let totalHours = hours + (days * 24);
        let totalHoursString = totalHours < 10 ? "0" + totalHours : totalHours;

        if (totalHoursString === "00") {
            return minutesString + ":" + secondsString;
        } else {
            return totalHours + ":" + minutesString + ":" + secondsString;
        }
    }

    deleteNewFile(file: any): void {
        this.newFiles.splice(this.newFiles.indexOf(file), 1);
        if (this.newFiles.length == 0) {
            this.inputFile.nativeElement.value = '';
        }
    }

    playAudioAgain(file): void {
        if (file.type.startsWith('audio/')) {
            this.audioElementSource.src = file.data;

            //call the load method as it is used to update the audio element after changing the source or other settings
            this.audioElement.load();

            //play the audio after successfully setting new src and type that corresponds to the recorded audio
            console.log("Playing audio...");
            this.audioElement.play();
            this.playing = true;
        } else {
            const link = document.createElement('a');

            link.setAttribute('href', file.data);
            link.setAttribute('download', file.name);
            link.click();
        }
    }

    deleteReal(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Aufgabe wird endgültig gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Task/deleteReal', {
                    id_task: this.id_task
                }).subscribe(() => {
                    this.messageService.sendMessage('deleteReal');
                    this.router.navigate(['/trash']);
                    this.toastrService.success('Die Aufgabe wurde gelöscht');
                });
            }
        });
    }

    triggerFileInput(): void {
        this.inputFile.nativeElement.click();
    };

    selectCustomer(item: any): void {
        this.form.patchValue({
            id_customer: item.id
        })
    }

    typeaheadNoResults(event: boolean): void {
        this.noResult = event;
    }

    selectContact(item: any): void {
        this.form.patchValue({
            id_contact: item.id
        })
    }

    typeaheadNoResultsContact(event: boolean): void {
        this.noResultContact = event;
    }

    duplicate() {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Aufgabe wird dupliziert.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Task/duplicate', {
                    id_task: this.id_task
                }).subscribe(response => {
                    this.router.navigate(['/task', response.insert.lastID]);
                    this.toastrService.success('Die Aufgabe wurde dupliziert');
                });
            }
        });
    }
}
